var map = {
	"./img_1.jpg": 34140,
	"./img_2.jpg": 14132,
	"./img_3.jpg": 68779,
	"./img_4.jpg": 64818,
	"./img_5.jpg": 18514,
	"./img_6.jpg": 92268
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 12463;